import PropTypes from 'prop-types';
import './LoadingSpinner.css';

/**
 * Loading Spinner Component
 * Reusable loading indicator
 */
const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClass = `spinner--${size}`;
  const classes = ['spinner', sizeClass, className].filter(Boolean).join(' ');

  return (
    <div className={classes} role="status" aria-label="Loading">
      <div className="spinner__circle"></div>
    </div>
  );
};

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
};

export default LoadingSpinner;